<template>
  <div class="page-container">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" label-width="200px">
      <p class="fs18 fwb pt0 mt0 mb30">Custom Page</p>
      <el-form-item label="Beginner Guide Link" prop="beginnerGuideLink" class="wd550">
        <el-input v-model="dataForm.beginnerGuideLink" placeholder="Beginner Guide Link"></el-input>
      </el-form-item>
      <el-form-item label="Beginner Guide Link(CN)" prop="beginnerGuideLinkCn" class="wd550">
        <el-input v-model="dataForm.beginnerGuideLinkCn" placeholder="Beginner Guide Link(CN)"></el-input>
      </el-form-item>
      <el-form-item label="Wechat Qr Code" prop="kfWechatQrcodeUrl" class="wd550">
        <el-image-uploader v-model="dataForm.kfWechatQrcodeUrl"></el-image-uploader>
      </el-form-item>
      <el-form-item label="WhatsApp Qr Code" prop="kfWhatsappQrcodeUrl" class="wd550">
        <el-image-uploader v-model="dataForm.kfWhatsappQrcodeUrl"></el-image-uploader>
      </el-form-item>
      <el-form-item label="Guide Banners" prop="guideBanners">
        <span class="lightGray">recommend: 750*532(w*h), png(format)</span>
        <el-multiple-file-uploader v-model="dataForm.guideBanners" accept="image/*"></el-multiple-file-uploader>
      </el-form-item>
      <el-form-item label="Guide Banners(CN)" prop="guideBannersCn">
        <span class="lightGray">recommend: 750*532(w*h), png(format)</span>
        <el-multiple-file-uploader v-model="dataForm.guideBannersCn" accept="image/*"></el-multiple-file-uploader>
      </el-form-item>
      <el-form-item label="">
        <el-button type="primary" @click="dataFormSubmit">Submit</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      dataForm: {
        beginnerGuideLink: "",
        beginnerGuideLinkCn: "",
        kfWechatQrcodeUrl: {},
        kfWhatsappQrcodeUrl: {},
        guideBanners: [],
        guideBannersCn: [],
      },
      dataRule: {
        beginnerGuideLink: [{ required: true, message: "please enter", trigger: "submit" }],
        beginnerGuideLinkCn: [{ required: true, message: "please enter", trigger: "submit" }],
        kfWechatQrcodeUrl: [
          {
            type: "object",
            required: true,
            fields: {
              url: { required: true, message: "please upload", trigger: "submit" },
            },
          },
        ],
        kfWhatsappQrcodeUrl: [
          {
            type: "object",
            required: true,
            fields: {
              url: { required: true, message: "please upload", trigger: "submit" },
            },
          },
        ],
        guideBanners: [{ type: "array", required: true, message: "please upload", trigger: "submit" }],
        guideBannersCn: [{ type: "array", required: true, message: "please upload", trigger: "submit" }],
      },
      dataFormLoading: false,
      submitControl: true,
    };
  },
  computed: {},
  activated() {
    this.getdataForm();
  },
  methods: {
    // 获取数据列表
    async getdataForm() {
      this.dataFormLoading = true;
      const { data } = await this.$http.get("/admin/stCustomPageManage/detail");
      this.dataForm = {
        beginnerGuideLink: (data && data.beginnerGuideLink) || "",
        beginnerGuideLinkCn: (data && data.beginnerGuideLinkCn) || "",
        kfWechatQrcodeUrl: (data && data.kfWechatQrcodeUrl) || null,
        kfWhatsappQrcodeUrl: (data && data.kfWhatsappQrcodeUrl) || null,
        guideBanners: (data && data.guideBanners) || [],
        guideBannersCn: (data && data.guideBannersCn) || [],
      };
      this.dataFormLoading = false;
    },
    // 表单提交
    dataFormSubmit() {
      this.$refs["dataForm"].validate(async valid => {
        if (valid && this.submitControl) {
          this.submitControl = false;
          const { code, msg } = await this.$http.post("/admin/stCustomPageManage/update", this.dataForm);
          if (code === 200) {
            this.$message({
              message: "success",
              type: "success",
              duration: 1500,
              onClose: () => {
                this.submitControl = true;
              },
            });
          } else {
            this.$message.error(msg);
            this.submitControl = true;
          }
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.lightGray {
  color: #7987a0;
}
</style>
